import PropTypes from 'prop-types';
import './Alert.css';

const TONES = ['info', 'success', 'warning', 'error'];

export default function Alert({
  tone = 'info',
  title,
  children,
  role = 'status',
}) {
  const t = TONES.includes(tone) ? tone : 'info';
  return (
    <div className={`alert alert--${t}`} role={role}>
      {title && <div className="alert__title">{title}</div>}
      {children && <div className="alert__body">{children}</div>}
    </div>
  );
}

Alert.propTypes = {
  tone: PropTypes.oneOf(TONES),
  title: PropTypes.node,
  children: PropTypes.node,
  role: PropTypes.string,
};
